<p-dialog 
  [(visible)]="visible" 
  [header]="'Special features' | translate"
  [modal]="true"
  [style]="{width: '450px', background: 'transparent'}"
  [closable]="true"
  [closeOnEscape]="true"
  (onHide)="closePanel()"
  styleClass="prime-adjustment-modal-dialog"
  [contentStyle]="{background: 'transparent'}">
  
  <div class="visual-impairments-content">
    <div class="theme-selection">
      <div class="theme-buttons">
        <button 
          *ngFor="let theme of themes"
          class="theme-button"
          [class.active]="selectedTheme === theme.id"
          (click)="selectTheme(theme.id)"
          [pTooltip]="theme.label | translate"
          tooltipPosition="bottom">
          <div class="theme-icon" [class]="'theme-' + theme.id">
            <i class="pi pi-circle-fill"></i>
          </div>
        </button>
      </div>
    </div>
    
    <div class="settings-section">
      <h4>{{ 'Zoom' | translate }}</h4>
      <app-slider
        [value]="fontSize"
        [min]="minFontSize"
        [max]="maxFontSize"
        [step]="fontSizeStep"
        [label]="'Scale size' | translate"
        unit="%"
        [showTicks]="true"
        [showButtons]="true"
        (valueChange)="fontSize = $event; onFontSizeChange()">
      </app-slider>
    </div>
    
    <div class="settings-section" *ngIf="selectedTheme !== 'standard'">
      <h4>{{ 'Contrast' | translate }}</h4>
      <app-slider
        [value]="contrastValue"
        [min]="minContrast"
        [max]="maxContrast"
        [step]="contrastStep"
        [label]="'Contrast level' | translate"
        unit="%"
        [showTicks]="true"
        [showButtons]="true"
        (valueChange)="onContrastChange($event)">
      </app-slider>
    </div>
  </div>
</p-dialog>